/** @prettier */

import {Card, CardContent, Stack, Box} from '@mui/material';
import {useLocation, useParams, Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

//MTH component import
import CardContents from '../../component/CardContents';
//interface import
import * as apiIF from '../../Type/api';

/**
 * その他空調機一覧
 * @param props props
 * @returns JSX.Element
 */
const OtherUnitSetting = (props: {
  /** その他空調機の情報 */
  slOtherInfo: apiIF.res.getCompositionsSLIFUnit | null;
  /** その他空調機の情報（set関数） */
  setSLOtherInfo: React.Dispatch<
    React.SetStateAction<apiIF.res.getCompositionsSLIFUnit | null>
  >;
}) => {
  const trans = useTranslation().t; //翻訳関数
  //URL取得
  const location = useLocation();
  //パスパラメータ取得
  const {systemType: slType} = useParams();

  //パスパラメータを取得できない場合
  //その他空調機の情報を取得できない場合
  if (slType === undefined || props.slOtherInfo === null) {
    return <></>;
  }
  return (
    <Card className="gwSetting__contents--unit">
      <CardContent>
        <Stack spacing={2}>
          <Box className="gwSetting__contents__title">
            <Link
              to={`${location.pathname}/sl-other-registration${location.search}`}
              id="mv-linkOtherSetting">
              {trans('OtherUnitSetting.linkTxt.interfaceSetting')}
            </Link>
          </Box>
          {/* 接続空調機 */}
          <Stack spacing={2} className="gwSetting__contents__contents">
            <CardContents
              class="gwSetting__contents__contents__underLine"
              valueDescription={trans('OtherUnitSetting.item.title.interface')}
              value={
                <Stack spacing={0}>
                  {props.slOtherInfo['unit-informations']
                    .filter(
                      //一致するSL系統のみ表示する
                      otherInfo => otherInfo['sl-system'] === slType.slice(2)
                    )
                    .map(otherInfo => (
                      <Box key={otherInfo['unit-id']}>
                        {otherInfo['unit-name']}
                      </Box>
                    ))}
                </Stack>
              }
            />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};
export default OtherUnitSetting;
